import {SimpleEnvWrapper} from "../jobs/wrapper/SimpleEnvWrapper";
import {SpendConcentration} from "../jobs/koi/spend-concentration/SpendConcentration";
import {KOIPurchasePriceVariance} from "../jobs/koi/purchase-price-variance/KOIPurchasePriceVariance";
import {MainComponent} from "../components/main/MainComponent";
import {KoiKeyDataFacts} from "../jobs/koi/key-data-facts/KoiKeyDataFacts";
import {KoiSupplierHierarchy} from "../jobs/koi/supplier-hierarchy/KoiSupplierHierarchy";
import {ManageDataPage} from "../pages/manage-data/ManageDataPage";
import {KOICashFlowOptimization} from "../jobs/koi/koi-cash-flow-optimization/KOICashFlowOptimization";
import {KOISupplierSegmentation} from "../jobs/koi/koi-supplier-segmentation/KOISupplierSegmentation";
import {routes} from './routes';
import {OpportunitiesTrello} from "../pages/opportunities-trello/OpportunitiesTrello";
import {TaxonomyEditorPage} from "../pages/taxonomy-editor/TaxonomyEditorPage";
import {ApprovalListPage} from "../pages/approval/ApprovalListPage";
import {ApprovalCategorizationPage} from "../pages/approval/categorization/ApprovalCategorizationPage";
import {ApprovalTaxonomyPage} from "../pages/approval/taxonomy/ApprovalTaxonomyPage";
import {TaxonomyMapperPage} from "../pages/taxonomy-mapper/TaxonomyMapperPage";
import {TaxonomyMapperReviewPage} from "../pages/taxonomy-mapper-review/TaxonomyMapperReviewPage";
import {ReportingPage} from "../pages/reporting/ReportingPage";
import {SupplierNormalizationPage} from "../pages/supplier-normalization/SupplierNormalizationPage";
import {DatasetOverviewPage} from '../pages/data-management/DatasetOverviewPage';
import {DataUploadPage} from '../pages/data-management/upload/DataUploadPage';
import {DataIngestionWrapper} from "../jobs/wrapper/DataIngestionWrapper";
import {DataMappingPage} from "../pages/data-management/DataMappingPage";
import {environment} from "../env";
import {TaxonomySuggestorPage} from "../pages/taxonomy-suggestor/TaxonomySuggestorPage";
import {AdvancedDashboard} from "../pages/advanced/AdvancedDashboard";
import {CategorizationPage} from "../pages/categorization/CategorizationPage";
import {TaxonomyHealthCheckPage} from "../pages/taxonomy-health-checker/TaxonomyHealthCheckPage";
import {BusinessCaseGeneratorPage} from "../pages/business-case-generator/BusinessCaseGeneratorPage";
import {BusinessCaseReportPage} from "../pages/business-case-generator/BusinessCaseReportPage";
import {GoldenRecordPage} from "../pages/golden-record/GoldenRecordPage";
import {TaxonomySuggestionDemoPage} from "../pages/taxonomy-suggestion-demo/TaxonomySuggestionDemoPage";
import {TaxonomySuggesterPageV2} from '../pages/taxonomy-suggester-v2/TaxonomySuggesterPageV2';
import {ContractInsightsPage} from "../pages/contract-insights/pages/ContractInsightsPage";
import {ContractAnalyticsPage} from "../pages/contract-insights/pages/ContractAnalyticsPage";
import {ContractOpportunities} from "../pages/contract-insights/pages/ContractOpportunities";
import {TaxonomyUploadPage} from "../pages/taxonomy-ingestion/TaxonomyUploadPage";
import {TaxonomyOverviewPage} from "../pages/taxonomy-ingestion/TaxonomyOverviewPage";
import {TaxonomyMappingPage} from "../pages/taxonomy-ingestion/TaxonomyMappingPage";
import {TaxonomyIngestionWrapper} from "../jobs/wrapper/TaxonomyIngestionWrapper";
import {KOIOpportunity} from "../pages/opportunity/OpportunityPage";
import {
    PpvOpportunityDetailPage
} from "../pages/opportunity/components/ppv-opportunity-detail/PpvOpportunityDetailPage";
import {SmallPpvComponentDemo} from "../test/echart-react-playground/echart-ppv-demo1";
import {EchartReactPlayground} from "../test/echart-react-playground/echart-react-playground";
import type {RouteOptions, RouteSpecification} from "./routeClasses";
import type {RouteWrapperProps} from "../jobs/wrapper/RouteWrapperProps";
import {ChatPage} from "../pages/chat-agent/ChatPage";
import {ChatDashboardsPage} from "../pages/chat-agent/ChatDashboardsPage";
import {DownloadRedirect} from "../pages/chat-agent/DownloadRedirect";
import {DashboardV3} from "../components/dashboard/v3/DashboardV3.tsx";
import {AutoSelectWrapper} from "../jobs/wrapper/AutoSelectWrapper.tsx";
import {Supplier360Page} from "../pages/supplier-360/Supplier360Page.tsx";
import {OpportunityIntelligencePage} from "../pages/opportunity-intelligence/OpportunityIntelligencePage.tsx";
import {ContractCoverageIntelligencePage} from "../pages/contract-coverage-intelligence/ContractCoverageIntelligencePage.tsx";
import {ContractCoverageZebraPage} from "../pages/contract-coverage-intelligence/zebra/ContractCoverageZebraPage.tsx";
import {PaymentTermsPage} from "../pages/payment-terms/PaymentTermsPage.tsx";
import {ContractLinkagePage} from "../pages/contract-linkage/ContractLinkagePage.tsx";
import {DailyBriefingPage} from "../pages/daily-briefing/DailyBriefingPage.tsx";
import {OpportunityDetailPage} from "../pages/daily-briefing/OpportunityDetailPage.tsx";
import React from "react";

const r = routes; // shortcut
type WO = RouteOptions<RouteWrapperProps, never>; //shortcut

/**
 * No data wrapper
 */
const noD: WO = {
    wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true, dataType: 'no_data'}}
}
const noDA: WO = {
    wrapper: SimpleEnvWrapper,
    wProps: {state: {fluid: true, dataType: 'no_data', appSection: 'approval'}}
} // No data wrapper

const auto: WO = {wrapper: AutoSelectWrapper, wProps: {state: {}}}
const sim: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true}}}
const sif: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: false}}}

const dwmNoData: WO = {
    wrapper: DataIngestionWrapper,
    wProps: {state: {fluid: true, dataType: 'no_data', appSection: 'ingestion'}}
}
const dwmData: WO = {
    wrapper: DataIngestionWrapper,
    wProps: {state: {fluid: true, appSection: 'ingestion'}}
}
const dwmNoTaxonomy: WO = {
    wrapper: TaxonomyIngestionWrapper,
    wProps: {state: {fluid: true, dataType: 'no_data', appSection: 'ingestion'}}
}
const dwmTaxonomy: WO = {
    wrapper: TaxonomyIngestionWrapper,
    wProps: {state: {fluid: true, appSection: 'ingestion'}}
}

const scl: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true, appSection: 'cleanup'}}}
const san: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true, appSection: 'analytics'}}}
const ssy: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true, appSection: 'synergy'}}}
const sop: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true}}} // opportunities
const sre: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true}}} // reporting
const sse: WO = {wrapper: SimpleEnvWrapper, wProps: {state: {fluid: true, appSection: 'settings'}}}

const noWrapper = {wrapper: MainComponent, wProps: {}} as RouteOptions<unknown, object> as WO;

/**
 * TODO: test the user flow on the CategorizationPage routes.
 *  With CAT-1214 we updated all CategorizationV1Page and AiCategorizationPage to CategorizationPage
 *  We would still need to test moved routes for consistency in the navigation flow
 */

// region wrappedRouting
const wrappedRouting: RouteSpecification<RouteWrapperProps>[] = ([] as RouteSpecification<RouteWrapperProps>[]).concat([
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Test routes
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    [noD, r.test_small_ppv_component, SmallPpvComponentDemo],
    [noD, r.test_react_integration, EchartReactPlayground],

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Mithra v3.0 Dashboard
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Cleanup
    [sim, r.cleanup_taxonomy_builder_id, TaxonomyEditorPage],
    [sim, r.cleanup_taxonomy_builder, TaxonomyEditorPage],
    [sim, r.cleanup_categorization, CategorizationPage],
    [sim, r.cleanup_supplier_normalization, SupplierNormalizationPage],
    [sim, r.cleanup_contract_insights, ContractInsightsPage],
    [sim, r.cleanup_golden_record, GoldenRecordPage],

    // Daily Briefing
    [sim, r.daily_briefing_opportunity, OpportunityDetailPage],
    [sim, r.daily_briefing, DailyBriefingPage],

    // Supplier 360
    [sim, r.supplier_360, Supplier360Page],

    // Opportunity Intelligence
    [sim, r.opportunity_intelligence, OpportunityIntelligencePage],

    // Contract Coverage Intelligence
    [sim, r.contract_coverage_intelligence, ContractCoverageIntelligencePage],
    [sim, r.contract_coverage_intelligence_v2, ContractCoverageZebraPage],

    // Payment Terms Optimisation
    [sim, r.payment_terms, PaymentTermsPage],

    // Contract Linkage
    [sim, r.contract_linkage, ContractLinkagePage],

    // Analytics
    [sif, r.analytics_dashboard, AdvancedDashboard],
    [san, r.analytics_koi_kdf, KoiKeyDataFacts],
    [san, r.analytics_koi_sc, SpendConcentration],
    [sim, r.analytics_koi_ppv_opportunity_detail, PpvOpportunityDetailPage],
    [sim, r.analytics_koi_ppv_opportunities, KOIOpportunity],
    [san, r.analytics_koi_ppv, KOIPurchasePriceVariance],
    [sif, r.analytics_koi_ss, KOISupplierSegmentation],

    // Stand-alone cards (to be placed in correct section later)
    // n/a

    // TODO: validate

    // Approval
    [noDA, r.approval_cat_detail, ApprovalCategorizationPage],
    [noDA, r.approval_tax_detail, ApprovalTaxonomyPage],
    [noDA, r.approval, ApprovalListPage],

    // Data Ingestion
    [dwmNoData, r.data_ingestion, DatasetOverviewPage],
    [dwmData, r.data_upload_mapping, DataMappingPage],
    [dwmNoData, r.data_upload, DataUploadPage],

    // Taxonomy Ingestion
    [dwmNoTaxonomy, r.taxonomy_ingestion, TaxonomyOverviewPage],
    [dwmTaxonomy, r.taxonomy_upload_mapping, TaxonomyMappingPage],
    [dwmNoTaxonomy, r.taxonomy_upload, TaxonomyUploadPage],

    // Chat
    [sim, r.chat_download, DownloadRedirect],
    [sim, r.chat_dashboards, ChatDashboardsPage],
    [sim, r.chat, ChatPage],

    // Bases of the app
    // Note: must be last otherwise it will catch all routes
    [auto, r.home, DashboardV3],
    [sim, r.homepage_dashboard, DashboardV3],
]).concat(environment.package === 'cleanup' ? [
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Cleanup dashboard
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // Placeholder for routes that interfere with the demo

] : []).concat(environment.package === 'sales_demo' ? [
    [san, r.demo_koi_cfo, KOICashFlowOptimization],
    [san, r.demo_koi_sh, KoiSupplierHierarchy],
    [sop, r.demo_opportunities, OpportunitiesTrello],
    [sop, r.demo_opportunities_id, OpportunitiesTrello],
    [sim, r.demo_merge_taxonomy_mapper_review, TaxonomyMapperReviewPage],
    [sim, r.demo_merge_taxonomy_mapper, TaxonomyMapperPage],
    [sim, r.demo_merge_taxonomy_suggester, TaxonomySuggestorPage],
    [sim, r.demo_opportunities, OpportunitiesTrello],
    [sim, r.demo_manage, ManageDataPage],
    [sif, r.demo_business_case_report_id, BusinessCaseReportPage],
    [sif, r.demo_business_case_report, BusinessCaseGeneratorPage],
    [scl, r.demo_cleanup_taxonomy_health_check, TaxonomyHealthCheckPage],
    [scl, r.demo_cleanup_taxonomy_suggestion_v1, TaxonomySuggestionDemoPage],
    [scl, r.demo_cleanup_taxonomy_suggestion_v2, TaxonomySuggesterPageV2],
    [san, r.demo_cleanup_analytics_contract_opportunities, ContractOpportunities],
    [san, r.demo_cleanup_analytics_contract_analytics, ContractAnalyticsPage],
    [ssy, r.demo_report, ReportingPage],
] : []);
// endregion

// region DPW demo routing (package 'dpw_demo' — see docs/dpw/)
// The DPW award demo is a standalone experience: it REPLACES the classic route set instead of extending it,
// so the demo build exposes no databag-coupled legacy modules. All pages render inside the DpwShell.
//
// IS_DPW_BUILD reads import.meta.env directly (statically replaced by Vite at build time) so that every
// non-DPW production build dead-code-eliminates this whole block: the DPW module graph — including its
// seeded fictional demo data and styles — must never be emitted into another customer's bundle.
// All DPW components load via dynamic import INSIDE the gated block, so no static edge exists either.
const IS_DPW_BUILD = import.meta.env.VITE_CUSTOMER === 'dpw';
const dpwRouting: RouteSpecification<RouteWrapperProps>[] = IS_DPW_BUILD ? (() => {
    const lazy = <P extends object>(load: () => Promise<{default: React.ComponentType<P>}>): React.FC<P> => {
        const L = React.lazy(load) as unknown as React.ComponentType<object>;
        return (props: P) => React.createElement(React.Suspense, {fallback: null}, React.createElement(L, props));
    };
    const dpwShell = {
        wrapper: lazy<{children?: React.ReactNode}>(() => import("../dpw/DpwShell.tsx").then(m => ({default: m.DpwShell}))),
    } as unknown as WO;
    const briefing = lazy<object>(() => import("../dpw/surfaces/briefing/BriefingPage.tsx").then(m => ({default: m.BriefingPage})));
    const initiatives = lazy<object>(() => import("../dpw/surfaces/initiative/InitiativesPage.tsx").then(m => ({default: m.InitiativesPage})));
    const strategy = lazy<object>(() => import("../dpw/surfaces/strategy/StrategyPage.tsx").then(m => ({default: m.StrategyPage})));
    const strategyIntake = lazy<object>(() => import("../dpw/surfaces/strategy/IntakePage.tsx").then(m => ({default: m.IntakePage})));
    const strategyFeedback = lazy<object>(() => import("../dpw/surfaces/strategy/FeedbackPage.tsx").then(m => ({default: m.FeedbackPage})));
    const strategyApproval = lazy<object>(() => import("../dpw/surfaces/strategy/ApprovalPage.tsx").then(m => ({default: m.ApprovalPage})));
    const levers = lazy<object>(() => import("../dpw/surfaces/levers/LeversPage.tsx").then(m => ({default: m.LeversPage})));
    const contractWindow = lazy<object>(() => import("../dpw/surfaces/levers/ContractWindowPage.tsx").then(m => ({default: m.ContractWindowPage})));
    const opportunity = lazy<object>(() => import("../dpw/surfaces/opportunity/OpportunityPage.tsx").then(m => ({default: m.OpportunityPage})));
    const initiativeCreate = lazy<object>(() => import("../dpw/surfaces/initiative/InitiativePreviewPage.tsx").then(m => ({default: m.InitiativePreviewPage})));
    const initiativeWorkspace = lazy<object>(() => import("../dpw/surfaces/initiative/InitiativeWorkspacePage.tsx").then(m => ({default: m.InitiativeWorkspacePage})));
    const financeReview = lazy<object>(() => import("../dpw/surfaces/value/FinanceReviewPage.tsx").then(m => ({default: m.FinanceReviewPage})));
    const endCard = lazy<object>(() => import("../dpw/surfaces/value/EndCardPage.tsx").then(m => ({default: m.EndCardPage})));
    const value = lazy<object>(() => import("../dpw/surfaces/value/ValuePage.tsx").then(m => ({default: m.ValuePage})));
    const recommendation = lazy<object>(() => import("../dpw/surfaces/recommendation/RecommendationPage.tsx").then(m => ({default: m.RecommendationPage})));
    const category = lazy<object>(() => import("../dpw/surfaces/category/CategoryPage.tsx").then(m => ({default: m.CategoryPage})));
    const foundation = lazy<object>(() => import("../dpw/surfaces/foundation/FoundationWorklistPage.tsx").then(m => ({default: m.FoundationWorklistPage})));
    const classification = lazy<object>(() => import("../dpw/surfaces/foundation/ClassificationReviewPage.tsx").then(m => ({default: m.ClassificationReviewPage})));
    const governance = lazy<object>(() => import("../dpw/surfaces/foundation/GovernancePage.tsx").then(m => ({default: m.GovernancePage})));
    const homeRedirect = lazy<object>(() => import("../dpw/DpwHomeRedirect.tsx").then(m => ({default: m.DpwHomeRedirect})));
    return [
        [dpwShell, r.dpw_briefing, briefing],
        [dpwShell, r.dpw_initiatives, initiatives],
        [dpwShell, r.dpw_foundation_classification, classification],
        [dpwShell, r.dpw_foundation_governance, governance],
        [dpwShell, r.dpw_foundation, foundation],
        [dpwShell, r.dpw_category_fm, category],
        [dpwShell, r.dpw_categories, category],
        [dpwShell, r.dpw_strategy_intake, strategyIntake],
        [dpwShell, r.dpw_strategy_feedback, strategyFeedback],
        [dpwShell, r.dpw_strategy_approval, strategyApproval],
        [dpwShell, r.dpw_strategy, strategy],
        [dpwShell, r.dpw_lever_spend_under_contract, contractWindow],
        [dpwShell, r.dpw_levers, levers],
        [dpwShell, r.dpw_opportunity, opportunity],
        [dpwShell, r.dpw_initiative_create, initiativeCreate],
        [dpwShell, r.dpw_initiative, initiativeWorkspace],
        [dpwShell, r.dpw_finance_review, financeReview],
        [dpwShell, r.dpw_end, endCard],
        [dpwShell, r.dpw_value, value],
        [dpwShell, r.dpw_recommendation, recommendation],
        [{wrapper: null} as unknown as WO, r.home, homeRedirect],
    ];
})() : [];
// endregion

// cast the specific type used in this file to a generic type used by the main router
export const routing: RouteSpecification[] = ([] as RouteSpecification[])
    .concat((IS_DPW_BUILD ? dpwRouting : wrappedRouting) as RouteSpecification[])
// Add more routes like this: .concat([] as RouteSpecification[])
